import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import sortBy from 'lodash-es/sortBy';

// common
import { ISnippet, IAdviceLink } from '@aa/common';

// shared
import { QnaStage } from '@aa/selfserv/shared';

// qna
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';

interface ISnippetSearchData {
  snippet: ISnippet;
  searchText: string;
  links: IAdviceLink[];
}

@Component({
  selector: 'aa-qna-snippet-index',
  templateUrl: './snippet-index.component.html',
  styleUrls: ['./index.component.scss']
})
export class QnaSnippetIndexComponent extends AbstractQnaComponent {

  public readonly snippetData: ISnippetSearchData[];
  public results: ISnippetSearchData[] = [];

  public showAdviceLinks: boolean = false;
  public showSnippetId:boolean = false;

  public readonly textFilter = new FormControl<string>(null);
  public readonly errorFilter = new FormControl<boolean>(false);
  public readonly adviceLinksOption = new FormControl<boolean>(this.showAdviceLinks);
  public readonly snippetIdOption = new FormControl<boolean>(this.showSnippetId);



  constructor(navigation: QnaNavigationService, route: ActivatedRoute) {
    super(navigation, 'Snippet Index', QnaStage.Advice);

    // advice links
    super.subscribe(this.adviceLinksOption.valueChanges, value => {
      this.showAdviceLinks = value;
      console.log("showAdviceLinks changes", value);
    });

    super.subscribe(this.snippetIdOption.valueChanges, value => {
      this.showSnippetId = value;
    });

    super.subscribe(this.textFilter.valueChanges, () => {
      this.rebuildSnippets();
    });

    super.subscribe(this.errorFilter.valueChanges, () => {
      this.rebuildSnippets();
    });

    // query
    super.subscribe(route.queryParamMap, params => {
      if(params.has('filter')) {
        this.textFilter.setValue(params.get('filter'));
      }
      if(params.has('showAdviceLinks')) {
        const value = Boolean(params.get('showAdviceLinks'))
        this.adviceLinksOption.setValue(value);
      }
      if(params.has('showSnippetId')) {
        const value = Boolean(params.get('showSnippetId'))
        this.snippetIdOption.setValue(value);
      }
    });

    this.snippetData = sortBy(this.data.snippets, o => o.description)
      .map( o => <ISnippetSearchData>{
        snippet: o,
        searchText: o.description.toLowerCase(),
        links: this.getAdviceLinks(o.id)
      });

    this.rebuildSnippets();
  }

  private getAdviceLinks(id: Guid): IAdviceLink[] {
    return this.data.adviceSets
      .filter(o => o.snippetIds.indexOf(id) >= 0)
      .map(o => <IAdviceLink>{
        text: o.name,
        href: this.navigation.getAdviceSetHref(o)
      });
  }

  private static isGuid(value: string) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value);
  }

  private rebuildSnippets() {

    let results = this.snippetData ?? [];

    // apply error filters
    if (this.errorFilter.value) {
      results = results.filter(o => o.snippet.errors);
    }

    // apply text filter
    let filter = this.textFilter.value;

    if (filter) {
      filter = filter.trim().toLowerCase();

      if(QnaSnippetIndexComponent.isGuid(filter)) {
        console.log("snippetId filter =",filter)
        results = results.filter(o => o.snippet.id == filter);
      } else {
        results = results.filter(o => o.searchText.indexOf(filter) >= 0);
      }
    }

    this.results = results;
  }
}
